import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.toggle = this.el.querySelector('[data-filtering-toggle]')
    this.filters = this.el.querySelectorAll('[data-filter]')
    this.ui = this.el.querySelector('[data-filtering-ui]')
    this.taxonomies = this.el.querySelectorAll('[data-filtering-tax]')
    this.items = this.el.querySelectorAll('[data-filtering-item]')

    this.toggle.addEventListener('click', () => {
      this.ui.classList.toggle('is-filtering-enabled')
    })

    this.taxonomies.forEach((tax) => {
      const toggle = tax.querySelector('[data-filtering-tax-toggle]')
      toggle.addEventListener('click', () => {
        tax.classList.toggle('is-tax-enabled')
      })
    })

    this.filters.forEach((filter) => {
      const { filter: filterName } = filter.dataset

      filter.addEventListener('click', () => {
        const isActive = filter.classList.contains('is-active')
        if (isActive) {
          filter.classList.remove('is-active')
          this.items.forEach((item) => {
            item.classList.remove('hidden')
          })
          return
        }

        this.filters.forEach((f) => {
          f.classList.toggle('is-active', f === filter)
        })

        this.items.forEach((item) => {
          const { filters: itemFilters } = item.dataset

          const matchingFilter = itemFilters.includes(filterName)
          item.classList.toggle('hidden', !matchingFilter)
        })
      })
    })
  }
}
